import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "countries",
  initialState: {
    data : [],
  },
  reducers: {
    setCountries: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setCountries } = appSlice.actions;
export default appSlice.reducer;